/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing F1 ${i?.season} season standings`)
};

const es_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrando la clasificación de F1 temporada ${i?.season}`)
};

const de_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`F1 ${i?.season} Saison-Tabelle`)
};

const nl_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`F1 ${i?.season} seizoensklassement`)
};

const fr_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Classement F1 saison ${i?.season}`)
};

const it_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Classifica F1 stagione ${i?.season}`)
};

const pt_br2_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Classificação F1 temporada ${i?.season}`)
};

const pt_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Classificação F1 época ${i?.season}`)
};

const ja_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`F1 ${i?.season}シーズン順位表`)
};

const zh_f1_standings_showing = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`F1 ${i?.season}赛季积分榜`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ season: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_standings_showing = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_standings_showing(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_standings_showing", locale)
	if (locale === "en") return en_f1_standings_showing(inputs)
	if (locale === "es") return es_f1_standings_showing(inputs)
	if (locale === "de") return de_f1_standings_showing(inputs)
	if (locale === "nl") return nl_f1_standings_showing(inputs)
	if (locale === "fr") return fr_f1_standings_showing(inputs)
	if (locale === "it") return it_f1_standings_showing(inputs)
	if (locale === "pt-BR") return pt_br2_f1_standings_showing(inputs)
	if (locale === "pt") return pt_f1_standings_showing(inputs)
	if (locale === "ja") return ja_f1_standings_showing(inputs)
	return zh_f1_standings_showing(inputs)
};